export default function (value: number, decimals: number) {
  return +value.toFixed(decimals);
}
